import { Box, Typography } from '@mui/material';

interface EstimateNoteProps {
  /** 見出し。「〜グループ → 推定 約N行／2年」のような1行 */
  headline: string;
  /** 閾値を超えているか。超えていれば枠付きの警告で見せる */
  warning: boolean;
  /** 警告のときだけ出す補足（どうすれば減るか） */
  warningDetail: string;
  /** 通常のときに見出しへ続ける補足 */
  note?: string;
  /** 下方向の余白（MUI の spacing） */
  marginBottom?: number;
}

/**
 * 行数見積もりの表示（FKV3-13111 / FKV3-13122）
 *
 * 縦持ちと掛け合わせで同じ見せ方をするため共通化している。
 * 閾値を超えたら枠付きで警告するが、保存は止めない（設計 D10：上限は設けず警告のみ）。
 */
export function EstimateNote({
  headline,
  warning,
  warningDetail,
  note,
  marginBottom = 0,
}: EstimateNoteProps) {
  return (
    <Box sx={{ mb: marginBottom }}>
      {warning ? (
        <div className="rounded-md border border-amber-300 bg-amber-50 p-2 text-xs text-amber-800">
          <div className="font-medium">{headline}</div>
          <div className="mt-1">{warningDetail}</div>
        </div>
      ) : (
        <Typography variant="caption" color="text.secondary">
          {headline}
          {note}
        </Typography>
      )}
    </Box>
  );
}
